// extracted by mini-css-extract-plugin
export default {"centerContainer":"ThankYou_centerContainer__O9urd","thankyou":"ThankYou_thankyou__gz9Jh","moveNextButton":"ThankYou_moveNextButton__f91Cp"};